import React from "react";
import { colors } from "../../constants/colors";
import mockupImage from "../../images/mockupImage.png";
import appStoreBadge from "../../images/appStoreBadge.svg";
export const Mission = () => {
  return (
    <section
      id="mission"
      // data-aos="fade-up-left"
      className="mission container-fluid"
      style={{ backgroundColor: colors.gencLightBlue, margin: 0 }}
    >
      <div className="mission-container">
        <div
          className="mission-details"
          data-aos="fade-right"
          data-aos-delay="250"
        >
          <h1 style={{ color: colors.gencBlue }}>
            Help family collect, store, and connect health data
          </h1>
          <p style={{ color: colors.gencBlackc }}>
            Apps and models to improve your family health
          </p>

          <div>
            <img
              style={{ height: 50, cursor: "pointer" }}
              src={appStoreBadge}
              alt="App Store Button"
            />
          </div>
        </div>

        <div data-aos="fade-left" data-aos-delay="250">
          <img src={mockupImage} alt="Mockup" />
        </div>
      </div>
    </section>
  );
};
